// for mobile view filter and sort button in plp page

document.addEventListener("DOMContentLoaded", function () {
  const filterButton = document.getElementById("filterButton");
  const drawerSummary = document.querySelector(".am-mobile-facets__disclosure summary");
  const drawer = document.querySelector(".am-mobile-facets-sort__disclosure summary")
  const mobileFilterButton = document.querySelector(".am-facets__mobile-filter-button");
  const sortButton = document.getElementById("sortbutton");
  const sortingOptions = document.querySelector(".am-mobile-facets-sort__disclosure");
  filterButton.addEventListener("click", function () {
    drawerSummary.click();
  });
  sortButton.addEventListener("click", function () {
    drawer.click();
  });
  // filter close button
  const mobileFilterCloseButton = document.querySelectorAll(".mobile--filter--close");
  const mobileSortCloseButton = document.querySelectorAll(".mobile--sort--close");

  const filterDisclosure = document.querySelector('.am-mobile-facets__disclosure');
  const sortDisclosure = document.querySelector('.am-mobile-facets-sort__disclosure');

  const body = document.body;
  mobileFilterCloseButton.forEach(Element => {
    Element.addEventListener("click", function () {
      filterDisclosure.removeAttribute('open');
      body.classList.remove('overflow-hidden-mobile');
    })
  })
  mobileSortCloseButton.forEach(Element => {
    Element.addEventListener("click", function () {
      sortDisclosure.removeAttribute('open');
      body.classList.remove('overflow-hidden-mobile');
    })
  })
});



// for filter checkbox
document.getElementById('clear-all').addEventListener('click', function () {
  const checkboxes = document.querySelectorAll('.mobile-facets__label > input[type="checkbox"]');
  checkboxes.forEach(function (checkbox) {
    if (checkbox.checked) {
      checkbox.checked = false;
    }
  });
});

//for filter responsive checkbox
document.getElementById('clearall').addEventListener('click', function () {
  const checkboxes = document.querySelectorAll('.mobile-facets__label > input[type="checkbox"]');
  checkboxes.forEach(function (checkbox) {
    if (checkbox.checked) {
      checkbox.checked = false;
    }
  });
});

